import React from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import AppHeader from "../components/AppHeader";
import AppFooter from "../components/AppFooter";
import "./App.css";
import Routes from "../router";
import OrganizationFetcher from "../components/OrganizationFetcher";
import StorageService from "../util/storage";

// apollo client
const client = new ApolloClient({
    uri: `${process.env.REACT_APP_BACKEND_URL}/graphql`,
    cache: new InMemoryCache(),
    headers: {
        Authorization: `${StorageService.getItem("bearer")}`,
    }
});

function App() {

    return (
        <div>
            <Router basename={process.env.REACT_APP_BASE_PATH}>
                <ApolloProvider client={client}>
                    <ToastContainer />
                    <OrganizationFetcher />
                    <div className="App">
                        <AppHeader />
                        <Routes />
                        <AppFooter />
                    </div>
                </ApolloProvider>
            </Router>
        </div>
    );
}

export default App;
